<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xl3 lg6 xs6>
                          <v-autocomplete
                            :items="tariffList"
                            v-model="filters.tarf"
                            :label="labels.tarf"
                            item-text="label"
                            item-value="value"
                            data-vv-name="tarf"
                            :data-vv-as="labels.tarf"
                            :error-messages="errors.collect('tarf')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xl3 lg6 xs6>
                          <v-autocomplete
                            :items="busClsList"
                            v-model="filters.busCls"
                            :label="labels.busCls"
                            item-text="label"
                            item-value="value"
                            data-vv-name="busCls"
                            :data-vv-as="labels.busCls"
                            :error-messages="errors.collect('busCls')"
                            clearable
                          ></v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <message :messages="messages"></message>
        <v-card-title>
          <v-spacer></v-spacer>
          <div>
            <v-btn color="primary" @click.native="doNew()">
              New Motor NCD Rate
              <v-icon right>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-data-table
          item-key
          :headers="headers"
          :items="items"
          v-bind:options.sync="pagination"
          :server-items-length="totalItems"
          :loading="loading"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row"
            ><tr>
              <td>{{ row.item.tarf }}</td>
              <td class="text-xs-left">{{ row.item.busCls }}</td>
              <td class="text-xs-left">{{ row.item.cvrType }}</td>
              <td class="text-xs-left">{{ row.item.ncbYr }}</td>
              <td class="text-xs-left">{{ formatDate(row.item.effDate) }}</td>
              <td class="text-xs-left">{{ row.item.ncbPct }}</td>
              <td class="text-xs-left">{{ convertPermitStatus(row.item.permitStatus) }}</td>
              <td class="table-action-header">
                <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove"></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove">Please confirm deletion of this records.</confirm>
      <v-dialog v-model="mtrNCDReview" width="1100px" persistent>
        <mtr-ncd-review :mtrNCDForm="mtrNCDForm" :newMtrNCD="newMtrNCD" @close="doClose"></mtr-ncd-review>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import MtrNcdReview from './MotorNCDRateReview'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Tariff', align: 'left', value: 'tarf' },
        { text: 'Class', value: 'busCls' },
        { text: 'Cover Type', value: 'cvrType' },
        { text: 'NCB Year', value: 'ncbYr' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'NCB Rate', value: 'ncbPct' },
        { text: 'Permit Status', value: 'permitStatus' },
        TableConst.tableActionHeader
      ],
      labels: {
        tarf: 'Tariff',
        busCls: 'Class'
      },
      filters: {
        tarf: null,
        busCls: null
      },
      mtrNCDForm: {
        tarf: null,
        busCls: null,
        cvrType: null,
        ncbYr: 0,
        effDate: new Date(),
        ncbPct: 0,
        permitStatus: '',
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      tariffList: [],
      busClsList: [],
      cvrTypeList: [],
      totalItems: 0,
      newMtrNCD: false,
      mtrNCDReview: false,
      loading: false,
      promptRemove: false,
      selectedMtrNCD: {},
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  computed: {
    menu() {
      return this.$store.state.uwMotorParam.mtrNCD.menu
    }
  },
  methods: {
    async doInit(options) {
      const apiURI = this.menu.getMtrNCDPage
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((mtrNCD) => {
                const convertList = {
                  id: {
                    tarf: mtrNCD.tarf,
                    busCls: mtrNCD.busCls,
                    cvrType: mtrNCD.cvrType,
                    ncbYr: mtrNCD.ncbYr,
                    effDate: mtrNCD.effDate
                  },
                  tarf: mtrNCD.tarf + ' - ' + mtrNCD.tarfDesc,
                  busCls: mtrNCD.busCls + ' - ' + mtrNCD.busClsDesc,
                  cvrType: mtrNCD.cvrType + ' - ' + mtrNCD.cvrType,
                  ncbYr: mtrNCD.ncbYr,
                  effDate: mtrNCD.effDate,
                  ncbPct: mtrNCD.ncbPct,
                  permitStatus: mtrNCD.permitStatus
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getTariffList() {
      const apiURI = this.menu.getTariffList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.tariffList = []
        if (data) {
          this.tariffList = data
        }
      }
    },
    async getBusClsList() {
      const apiURI = this.menu.getBusClsListByBusClsAppId
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.busClsList = []
        this.busClsList = result.data
        if (data) {
          this.busClsList = data
        }
      }
    },
    convertPermitStatus(ps) {
      if (ps === 'A') {
        return 'Accepted'
      } else if (ps === 'D') {
        return 'Declined'
      } else {
        return 'Referred'
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.tarf = null
      this.filters.busCls = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll('filter').then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    async doReview(listData) {
      this.resetMessages()
      const apiURI = this.menu.getMtrNCD
      const expand = {
        tarf: listData.id.tarf,
        busCls: listData.id.busCls,
        cvrType: listData.id.cvrType,
        ncbYr: listData.id.ncbYr,
        effDate: formatDisplayDate(listData.id.effDate)
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.mtrNCDForm.tarf = data.mtrNCD.tarf
          this.mtrNCDForm.busCls = data.mtrNCD.busCls
          this.mtrNCDForm.cvrType = data.mtrNCD.cvrType
          this.mtrNCDForm.ncbYr = data.mtrNCD.ncbYr
          this.mtrNCDForm.effDate = data.mtrNCD.effDate
          this.mtrNCDForm.ncbPct = data.mtrNCD.ncbPct
          this.mtrNCDForm.permitStatus = data.mtrNCD.permitStatus
          this.mtrNCDForm.createdName = data.mtrNCD.createdName
          this.mtrNCDForm.createdDate = data.mtrNCD.createdDate
          this.mtrNCDForm.modifiedName = data.mtrNCD.modifiedName
          this.mtrNCDForm.modifiedDate = data.mtrNCD.modifiedDate

          this.newMtrNCD = false
          this.mtrNCDReview = true
        }
      }
    },
    async doQuery(listData) {
      this.resetMessages()
      const apiURI = this.menu.getMtrNCD
      const expand = {
        tarf: listData.id.tarf,
        busCls: listData.id.busCls,
        cvrType: listData.id.cvrType,
        ncbYr: listData.id.ncbYr,
        effDate: formatDisplayDate(listData.id.effDate)
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.mtrNCDForm.tarf = data.mtrNCD.tarf
          this.mtrNCDForm.busCls = data.mtrNCD.busCls
          this.mtrNCDForm.cvrType = data.mtrNCD.cvrType
          this.mtrNCDForm.ncbYr = data.mtrNCD.ncbYr
          this.mtrNCDForm.effDate = data.mtrNCD.effDate
          this.mtrNCDForm.ncbPct = data.mtrNCD.ncbPct
          this.mtrNCDForm.permitStatus = data.mtrNCD.permitStatus
          this.mtrNCDForm.createdName = data.mtrNCD.createdName
          this.mtrNCDForm.createdDate = data.mtrNCD.createdDate
          this.mtrNCDForm.modifiedName = data.mtrNCD.modifiedName
          this.mtrNCDForm.modifiedDate = data.mtrNCD.modifiedDate

          this.newMtrNCD = null
          this.mtrNCDReview = true
        }
      }
    },
    doNew() {
      this.newMtrNCD = true
      this.mtrNCDReview = true
    },
    doClose() {
      this.mtrNCDReview = false
      this.doInit(false)
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedMtrNCD = data.item.id
      this.promptRemove = true
    },
    async doRemove() {
      const apiURI = this.menu.deleteMtrNCD
      if (apiURI) {
        const expand = this.selectedMtrNCD
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  async mounted() {
    if (this.$store.state.uwMotorParam.mtrNCD.init !== 1) {
      await this.$store.dispatch('MtrNCDInit')
    }
    this.getTariffList()
    this.getBusClsList()
    this.doInit(true)
  },
  components: {
    MtrNcdReview
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
